import { Pipe, PipeTransform } from '@angular/core';
import { isDefined } from '@angular/compiler/src/util';
import { EmbryoService } from '../Services/Embryo.service';

@Pipe({
  name: 'exchange'
})
export class ExchangePipe implements PipeTransform {
constructor(private embryoService:EmbryoService){
  
}
  transform(value: any, exchangeMX?: any): any {
    if(isDefined(exchangeMX))
      return value*exchangeMX;
    return value*this.embryoService.$exchangeMX.value;
  }

}
